import { mountClassic } from '../render/classic/classic-app.js';
import { pyramidClassicSpec } from '../variants/pyramid/classic-spec.js';

const root = document.getElementById('classic-stage');
if (!root) throw new Error('missing #classic-stage');
mountClassic(pyramidClassicSpec, { root, title: 'Pyramid' });
